import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { FeaturesModule } from "../blocks/FeaturesModule";

type IProps = Immutable<templates.FeaturesModuleTemplate>;

export const Template = (props: IProps): React.JSX.Element => {
    return <FeaturesModule value={props.value} />;
};
